import { render, staticRenderFns } from "./StageFrame.vue?vue&type=template&id=dd46378c&scoped=true&"
import script from "./StageFrame.vue?vue&type=script&lang=js&"
export * from "./StageFrame.vue?vue&type=script&lang=js&"
import style0 from "./StageFrame.vue?vue&type=style&index=0&id=dd46378c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd46378c",
  null
  
)

export default component.exports